import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle, X } from 'lucide-react';
const names = ['Matías', 'Joaquín', 'Nicolás', 'Agustín', 'Franco', 'Santiago', 'Diego', 'Facundo', 'Tomás', 'Lucas', 'Mateo', 'Enzo', 'Julián', 'Bautista', 'Thiago'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Bahía Blanca', 'Neuquén', 'Santa Fe', 'San Juan', 'Paraná', 'Posadas', 'Resistencia'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    city: '',
    time: 1
  });
  useEffect(() => {
    const showRandomPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 59) + 1;
      setCurrentPurchase({
        name: randomName,
        city: randomCity,
        time: randomTime
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 6000);
    };
    const initialTimer = setTimeout(showRandomPopup, 5000);
    const intervalTimer = setInterval(() => {
      showRandomPopup();
    }, Math.floor(Math.random() * 5000) + 15000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-159">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -50,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -50,
      transition: {
        duration: 0.3
      }
    }} className="fixed bottom-6 left-6 z-40 bg-white border border-brand-border rounded-lg shadow-2xl p-4 pr-10 max-w-sm flex items-start gap-3" data-id="element-160">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-brand-muted hover:text-brand-text transition-colors" data-id="element-161">
            <X className="w-4 h-4" data-id="element-162" />
          </button>

          <div className="flex-shrink-0 mt-1" data-id="element-163">
            <CheckCircle className="w-6 h-6 text-brand-green" data-id="element-164" />
          </div>

          <div data-id="element-165">
            <p className="text-sm text-brand-text" data-id="element-166">
              <strong className="font-bold" data-id="element-167">{currentPurchase.name}</strong> de{' '}
              <strong className="font-bold" data-id="element-168">{currentPurchase.city}</strong>{' '}
              acaba de comprar el Manual del 5 Moderno
            </p>
            <p className="text-xs text-brand-muted mt-1" data-id="element-169">
              hace {currentPurchase.time}{' '}
              {currentPurchase.time === 1 ? 'minuto' : 'minutos'}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}